'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { LoadingContainer, StateLayer, StyledAction, TextContainer } from './elements';
import { isComponentType, usePropDeprecation, DefaultsProvider, DefaultsContext, attachSubComponents } from '../../util';
import { Icon } from '../Icon';
import { flattenChildren } from '../../util/helpers/flattenChildren';
import { InlineLoader } from '../Loaders';
import { Inline } from './Inline';
import { MicroAction as Micro } from './MicroAction';
const actionToLoaderSize = {
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem'
};
export const Action = attachSubComponents('RefAction', /*#__PURE__*/React.forwardRef(({
  children,
  href,
  size,
  variant = 'filled',
  state = 'enabled',
  className,
  actionRef,
  ...props
}, fRef) => {
  const childArr = flattenChildren(children).filter(a => a);
  const hasLeftIcon = isComponentType(childArr[0], Icon) || isComponentType(childArr[0], Icon.SSR) || isComponentType(childArr[0], Icon.Compat);
  const hasRightIcon = childArr.length > 1 && (isComponentType(childArr[childArr.length - 1], Icon) || isComponentType(childArr[childArr.length - 1], Icon.SSR) || isComponentType(childArr[childArr.length - 1], Icon.Compat));
  let content = childArr.slice(hasLeftIcon ? 1 : 0, hasRightIcon ? -1 : undefined);
  if (content.length === 0) content = null;
  const iconVariant = getIconVariant(childArr, hasLeftIcon, hasRightIcon);
  const disabled = props.disabled;
  usePropDeprecation({
    name: 'disabled',
    version: '5.0.0',
    alternative: 'state',
    value: disabled
  });
  const {
    actionSize
  } = React.useContext(DefaultsContext);
  size ??= actionSize ?? 'md';
  return /*#__PURE__*/React.createElement(StyledAction, _extends({
    ref: fRef || actionRef,
    "data-aui": "action",
    $size: size,
    $variant: variant,
    $state: disabled ? 'disabled' : state,
    $iconVariant: iconVariant,
    as: href ? 'a' : 'button',
    "aria-disabled": state === 'readonly' || state === 'loading' || state === 'disabled',
    className: `${variant === 'flat' ? 'aui-action-flat' : ''} ${className}`
  }, href && state !== 'disabled' ? {
    href,
    ...props
  } : {
    disabled: state === 'disabled',
    ...props
  }), /*#__PURE__*/React.createElement(DefaultsProvider, {
    value: {
      iconSize: getDefaultIconSize(size, iconVariant),
      iconFill: 'currentColor'
    }
  }, /*#__PURE__*/React.createElement(StateLayer, null), state === 'loading' && /*#__PURE__*/React.createElement(LoadingContainer, null, /*#__PURE__*/React.createElement(InlineLoader, {
    width: actionToLoaderSize[size]
  })), hasLeftIcon && childArr[0], content && /*#__PURE__*/React.createElement(TextContainer, null, content), hasRightIcon && childArr[childArr.length - 1]));
}), {
  Inline,
  Micro
});
function getIconVariant(childArr, hasLeftIcon, hasRightIcon) {
  if (childArr.length === 1 && hasLeftIcon) {
    return 'only';
  } else if (hasLeftIcon && hasRightIcon) {
    return 'both';
  } else if (hasLeftIcon) {
    return 'left';
  } else if (hasRightIcon) {
    return 'right';
  } else {
    return 'none';
  }
}
function getDefaultIconSize(size, iconVariant) {
  if (size === 'sm') {
    return 'normal';
  } else if (size === 'md') {
    return 'large';
  } else if (size === 'lg' && iconVariant === 'only') {
    return 'xlarge';
  } else if (size === 'lg') {
    return 'large';
  }
}